import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Globals } from '../../globals';

@Component({
    selector: 'app-detailcontent',
    templateUrl: './detailcontent.component.html',
    styleUrls: ['./detailcontent.component.css']
})
export class DetailcontentComponent implements OnInit {

    public listgroup = [];
    public parent_link: any
    public contentdetail = {};
    public link: any;
    public linkshare;
    public dataDM: any
    public token: any = {
        getListContentDetail: "api/getcontentdetail",
        getlistByGroupContent: "api/getlistcontentByGroup",
        updateViews: "api/updateViewsContent",
        getDanhmucContent: "api/getDanhmucContent",
    }
    public connect;
    constructor(public route: ActivatedRoute, public router: Router, public globals: Globals) {
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getListContentDetail":
                    this.contentdetail = res.data;
                    this.linkshare = this.globals.BASE_API_URL + 'tin-tuc/' + this.contentdetail['linkgroup'] + '/' + this.contentdetail['link'];
                    setTimeout(() => {
                        if (window["twentytwenty"]) {
                            window["twentytwenty"]();
                        }
                    }, 50);
                    break;
                case "getlistByGroupContent":
                    this.listgroup = res.data;
                    break;
                case "getDanhmucContent":
                    this.dataDM = res.data;
                    break;
                default:
                    break;
            }
        });

    }

    ngOnInit() {
        setTimeout(() => {
            if (window["twentytwenty"]) {
                window["twentytwenty"]();
            }
        }, 100);
        this.globals.send({ path: this.token.getDanhmucContent, token: "getDanhmucContent" });
        this.route.params.subscribe(params => {
            this.link = params.link;

            this.globals.send({ path: this.token.getListContentDetail, token: "getListContentDetail", params: { link: this.link } });

            this.parent_link = params.parent_link;

            this.globals.send({ path: this.token.getlistByGroupContent, token: "getlistByGroupContent", params: { link: this.parent_link } });

        });
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                let route: string = event.url;
                let t: string = '/tin-tuc/' + this.parent_link + '/' + this.link
                let control = (route === t) ? true : false;
                if (control) {
                    this.globals.send({ path: this.token.updateViews, token: 'updateViews', params: { link: this.link } });

                };
            }
        })


    }
    changeImages = () => {
        let listImg: any = document.getElementById('detail').querySelectorAll('img');
        for (let i = 0; i < listImg.length; i++) {
            let parent = listImg[i].parentNode;
            let src = listImg[i].src;
            let html = "<div class=' border-0'><div class='post-image' style='position: relative'>";
            html += "<div class='image-bg js-svg-container'>";
            html += "<svg viewBox='0 0 762.25 325.25' preserveAspectRatio = 'none' width = '100%' style = 'display: block; fill: transparent; stroke: #b04a5b; position' >";
            html += "<path d='M10.750,0.750 L730.750,20.750 C736.273,20.750 740.750,25.227 740.750,30.750 L760.750,303.749 C760.750,309.272 756.273,313.750 750.750,313.750 L30.750,323.750 C25.227,323.750 20.750,319.273 20.750,313.750 L0.750,10.750 C0.750,5.227 5.227,0.750 10.750,0.750 Z'></path></svg>"
            html += "</div>";
            html += "<div class='image js-svg-container' >";
            html += "<svg viewBox='0 0 820 333' preserveAspectRatio = 'none' width = '100%'  style = 'display: block; position: absolute; top: 0;' >"
            html += "<image xlink: href='" + src + "' width = '100%'  style='clip-path: url(#postMask3);' > </image></svg></div></div></div>"
            html += "<svg class='svg-defs' viewBox='0 0 820 400' width='100%' height='100%'  preserveAspectRatio='none'>"
            html += "<defs>"
            html += "<clipPath id='postMask3' >"
            html += "<path d='M10.000,10.000 L790.000,-0.000 C795.523,-0.000 800.000,4.477 800.000,10.000 L820.000,322.999 C820.000,328.522 815.523,333.000 810.000,333.000 L30.000,313.000 C24.477,313.000 20.000,308.523 20.000,303.000 L0.000,20.000 C0.000,14.477 4.477,10.000 10.000,10.000 Z'> </path>"
            html += "</clipPath>"
            html += " </defs>"
            html += " </svg>";
            parent.innerHTML = html;
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/frontend/detailcontent/detailcontent.component.ts